export const state = {
    errorStatus: {
        hasError: false,
        errorMessage: [],
    },
}

export const mutations = {
    SET_ERROR_STATUS(state, payload) {
        state.errorStatus = payload
    }
}

export const getters = {
}

export const actions = {
    errorHandler({ commit }, error) {
        if (error.response) {
            this.errorStatus.errorMessage = error.response.data.errors
                ? error.response.data.errors
                : [error.response.data];
            commit('SET_ERROR_STATUS', {
                hasError: true, errorMessage: error.response.data.errors
                    ? error.response.data.errors
                    : [error.response.data]
            })
        } else {
            this.errorStatus.errorMessage = [error];
            commit('SET_ERROR_STATUS', { hasError: true, errorMessage: [error] })
        }
    },

    cleanError({ commit }) {
        commit('SET_ERROR_STATUS', { hasError: false, errorMessage: [] })
    },
}